'use client';

import { useCallback, useState } from 'react';
import type { MaterialRequest } from '@paeffgen/react/crm-documents/data-access-graphql';
import { useCart } from './cart-provider';

/**
 * Steuert die "Erneut anfragen"-Aktion gemäß Produktentscheidung:
 * - aktueller Entwurf leer  → direkt übernehmen (kein Dialog nötig)
 * - aktueller Entwurf gefüllt → Dialog mit Wahl append/replace
 *
 * Wird von der Verlaufsliste UND der Detail-Ansicht genutzt (DRY).
 */
export function useReorderRequest() {
  const { itemCount, reorderFromRequest } = useCart();
  const [pending, setPending] = useState<MaterialRequest | null>(null);

  const requestReorder = useCallback(
    (request: MaterialRequest) => {
      if (request.items.length === 0) return;
      if (itemCount === 0) {
        // Konfliktfrei: leeren Entwurf direkt mit den Positionen befüllen.
        void reorderFromRequest(request.items, 'replace');
        return;
      }
      setPending(request);
    },
    [itemCount, reorderFromRequest],
  );

  const confirm = useCallback(
    (mode: 'append' | 'replace') => {
      if (!pending) return;
      void reorderFromRequest(pending.items, mode);
      setPending(null);
    },
    [pending, reorderFromRequest],
  );

  const cancel = useCallback(() => setPending(null), []);

  return { pending, requestReorder, confirm, cancel };
}
